// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { number, string } from 'prop-types'
import { convertDDtoDMSPref } from 'helpers/coordsConversion'

const SuggestionDetails = props => {
  const {
    asr, callSign, elevation, elevationUS,
    latitude, longitude, siteName, top, unitType,
  } = props

  const asrNode = (
    asr
      ? <dd>{`ASR: ${asr}`}</dd>
      : null
  )

  const callSignNode = (
    callSign
      ? <dd>{`Call Sign: ${callSign}`}</dd>
      : null
  )

  const geWithUnit = (
    unitType === 'SI'
      ? `${elevation} m`
      : `${elevationUS} ft`
  )

  return (
    <dl className={'main-font'} style={{ top }}>
      <dt>{siteName}</dt>
      <dd>{`Lat: ${convertDDtoDMSPref(latitude, 'latitude')}`}</dd>
      <dd>{`Long: ${convertDDtoDMSPref(longitude, 'longitude')}`}</dd>
      <dd title={'Ground Elevation'}>{`G.E: ${geWithUnit}`}</dd>
      {asrNode}
      {callSignNode}
    </dl>
  )
}

SuggestionDetails.propTypes = {
  asr: number,
  callSign: string,
  elevation: number.isRequired,
  elevationUS: number.isRequired,
  latitude: number.isRequired,
  longitude: number.isRequired,
  siteName: string.isRequired,
  top: string.isRequired,
  unitType: string.isRequired,
}

export default SuggestionDetails
